import * as React from 'react'

import Button from '../../components/button'
import WaveContainer from '../../components/wave-container'

import DooerLive from '../dooer-live'
import Footer from '../footer'

import styles from './generic-page.module.scss'

interface IGenericPageProps {
  titleText: React.ReactNode
  ledeText: React.ReactNode
  buttonText?: React.ReactNode
  children: React.ReactNode
  href?: string
}
const GenericPage = ({ titleText, ledeText, buttonText, children, href }: IGenericPageProps) => {
  return (
    <>
      <div className={styles.root}>
        <h1 className={styles.heading}>{titleText}</h1>
        <p className={styles.lede}>{ledeText}</p>
        {buttonText && (
          <Button className={styles.button} href={href || '/vara-tjanster'}>
            {buttonText}
          </Button>
        )}
      </div>

      <WaveContainer>
        <div className={styles.content}>
          <div className={styles.contentInner}>{children}</div>
        </div>
      </WaveContainer>
      <DooerLive inverted />
      <Footer inverted />
    </>
  )
}

export default GenericPage
